export default "__VITE_ASSET__BT0Gu4_R__"